import React from 'react'

const Contacts = () => {
  return (
    <div className="container py-5">
      <h1 className="text-center mb-5 text-dark">Contact Us</h1>
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card shadow p-4">
            <h5 className="text-dark mb-3">Phone</h5>
            <p><strong>Tel:</strong> +254114350889</p>
            
            <h5 className="text-dark mb-3 mt-4">Email</h5>
            <p><strong>Email:</strong> <a href="mailto:stepsinternational22@gmail.com">stepsinternational22@gmail.com</a></p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Contacts
